import { useCallback, useState } from 'react';

type OrderDirection = 'asc' | 'desc';

export type OrderIndexData = {
  index: string;
  direction: OrderDirection;
};

type FunctionHandleSort = <T>(index: string, source: Array<T>) => Array<T>;

type TableOrder = [OrderIndexData, FunctionHandleSort];

export default function useTableOrder(): TableOrder {
  const [indexFiltered, setIndexFiltered] = useState<OrderIndexData>({
    index: '',
    direction: 'asc',
  });

  const handleSort = useCallback(
    <T>(index: string, source: Array<T>): Array<T> => {
      const direction = indexFiltered.direction === 'asc' && index === indexFiltered.index ? 'desc' : 'asc';

      source = JSON.parse(JSON.stringify(source));

      setIndexFiltered({
        index,
        direction,
      });

      const before = direction === 'asc' ? -1 : 1;

      return source.sort((a, b) => {
        const left = (a as Record<string, number | string>)[index];
        const right = (b as Record<string, number | string>)[index];

        if (left < right) return before;
        if (left > right) return -before;
        return 0;
      });
    },
    [indexFiltered],
  );

  return [indexFiltered, handleSort];
}
